import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { AdminUserAction } from '../../actions';
import { Translate as t } from '../../config/Translate';
import { ORG_HQ } from '../../config/appConstants';
import { history } from '../../history';
import { Loading } from '../../components/common/Loading';
import AdminUserEditInfo from './AdminUserEditInfo';
import AdminUserEditUpdatePassword from './AdminUserEditUpdatePassword';

const AdminUserEdit = ({ authuser, user, DeleteUser, isUpdateRes, ClearUpdateResult, GetUser }) => {

    const { adminid } = useParams();
    const [view, setView] = useState("info");
    const [tab, setTab] = useState(view || "info");
    const [canedit, setCanEdit] = useState(false);
    const [editable, setEditable] = useState(false);

    // 조회 완료 전에는 직전에 본 사용자(redux user)가 보이지 않도록 본문 대신 Loading.
    // redux isLoading 은 저장/삭제에도 토글돼 폼이 언마운트되므로 쓰지 않고 지역 state 로 관리.
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        let alive = true;
        Promise.resolve(GetUser(adminid))
            .catch((e) => {
                console.warn('[AdminUserEdit] GetUser failed', { screen: 'AdminUserEdit', adminid, reason: String(e?.message ?? e).slice(0, 200) });
            })
            .finally(() => { if (alive) setFetching(false); });
        return () => { alive = false; };
    }, []);

    // 조회가 실패하면 redux user 는 직전에 본 사용자로 남는다. 경로의 adminid 와 정확히 같을 때만 본문·쓰기 컨트롤을 그린다.
    // (서버 GET /user/:adminid 가 adminid 완전 일치 조회라 대소문자 변환 없이 === 비교)
    const isCurrent = !!user?.adminid && user.adminid === adminid;
    const ready = !fetching && isCurrent;

    useEffect(() => {
        setCanEdit(authuser.adminType == "S" || authuser.adminType == "M" || adminid == authuser.adminid || (authuser.companyInfo && authuser.companyInfo.org == ORG_HQ) || authuser.companyId == 'RAY02091');
    }, [user]);

    useEffect(() => {
        if (view == "deluserconfirm" && isUpdateRes) {
            ClearUpdateResult();
            history.push("/Admin/AdminUserList");
        }
    }, [isUpdateRes]);

    // SEC-083 (#484) — 서버가 본인 삭제를 403 으로 막으므로 화면에서도 버튼/실행을 감춘다.
    // canedit 자체는 건드리지 않는다(편집 잠금 해제·비밀번호 변경 버튼도 함께 가리기 때문).
    const isSelf = adminid == authuser?.adminid;

    const handleDeleteUser = (e) => {
        if (isSelf || !isCurrent) return;
        DeleteUser(user.adminid);
    }

    const tabList = [
        { code: "info", title: "Information" }
    ]

    return (
        <>
            <div className="extraHeader">
                <h2 className="mb-0">
                    {ready && user.adminid}
                    {(ready && canedit && view == "info") &&
                        <a href onClick={() => setEditable(!editable)} className="btn btn-secondary btn-sm mt-0 ms-1">
                            <ion-icon name={editable ? "lock-open-outline" : "lock-closed-outline"} />
                            {editable ? t('common.status.unlocked') : t('common.status.locked')}
                        </a>}
                </h2>
                <div className="ray-right">
                    {ready && canedit && <>
                        {view != "deluserconfirm" && !isSelf && <button className="btn btn-danger btn-sm mt-0 me-1" onClick={() => setView('deluserconfirm')}>{t('user.button.deleteUser')}</button>}
                        {view != "updatepassword" && <button className="btn btn-warning btn-sm mt-0 me-1" onClick={() => setView('updatepassword')}>{t('auth.button.updatePassword')}</button>}
                        {view != "info" && <button className="btn btn-primary btn-sm mt-0 me-1" onClick={() => setView('info')}>Edit User</button>}
                    </>}
                    <Link to="/Admin/AdminUserList" className="btn btn-outline-default btn-sm mt-0 me-1">{t('common.label.list')}</Link>
                </div>
            </div>
            <div id="appCapsule" className="extra-header-active full-height">
                <div className="section mt-1 mb-1 ">
                </div>
                {fetching && <Loading />}
                {!fetching && !isCurrent && <div className="section"><p className="text-center">{t('common.message.noData')}</p></div>}
                {ready && view == "info" && <AdminUserEditInfo user={user} adminid={adminid} editable={editable} canedit={canedit} cancelcallback={() => setEditable(false)} />}
                {ready && view == "deluserconfirm" && !isSelf &&
                    <div className="section">
                        <div className="card bg-danger text-white">
                            <div className="card-header">
                                <div className="card-title">경고!</div>
                            </div>
                            <div className="card-body">
                                <h3>즉시 반영됩니다!!!</h3>
                                <p>이 작업은 되돌릴 수 없는 작업입니다.</p>
                                <p>정말 삭제하시겠습니까?</p>
                            </div>
                        </div>
                        <button className="btn btn-outline-danger" onClick={handleDeleteUser}>{t('user.button.deleteUser')}</button>
                    </div>
                }
                {ready && view == "updatepassword" && <AdminUserEditUpdatePassword user={user} adminid={adminid} />}
            </div>
        </>
    );
};

const mapState = (state) => {
    const isUpdateRes = state.AdminUserReducer.isUpdateRes;
    const user = state.AdminUserReducer.user;
    const authuser = state.AuthReducer.user;
    return { authuser, user, isUpdateRes };
};

const mapDispatch = (dispatch) => ({
    GetUser: (adminid) => dispatch(AdminUserAction.GetUser(adminid)),
    DeleteUser: (adminid) => dispatch(AdminUserAction.DeleteUser(adminid)),
    updateUserInfo: (adminid, data) => dispatch(AdminUserAction.UpdateUserInfo(adminid, data)),
    registUserInfo: (data) => dispatch(AdminUserAction.RegistUserInfo(data)),
    ClearUpdateResult: () => dispatch(AdminUserAction.ClearUpdateResult()),
});

export default connect(mapState, mapDispatch)(AdminUserEdit);
